module.exports = __webpack_public_path__ + "static/media/cards.3a31f547.png";